
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { JoinDialogProvider } from "./context/JoinDialogProvider.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <JoinDialogProvider> 
      <App />
      </JoinDialogProvider>
   
  </React.StrictMode>
);
